import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import cx from 'classnames';
import s from './MainMenu.css';


const MainMenuListItem = ({ closeMainMenu, title, path, className, isActive }) => {
  const active = isActive ? s.active : '';

  return (
    <li className={s.listItem}>
      <Link
        to={path}
        id={title}
        title={title}
        className={cx(s.menuButton, className.button, active)}
        onClick={closeMainMenu}
      >
        <div className={s.iconCircle}>
          <div className={className.icon}/>
        </div>
        <p className={s.menuButtonText}>
          {title}
        </p>
        <div className={s.arrowRight}/>
      </Link>
    </li>
  );
};

MainMenuListItem.propTypes = {
  closeMainMenu: PropTypes.func,
  title: PropTypes.string,
  path: PropTypes.string,
  className: PropTypes.object,
  isActive: PropTypes.bool,
};

export default MainMenuListItem;



// WEBPACK FOOTER //
// ./src/components/MainMenu/MainMenuListItem.js